import React, { FC, useState } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { format } from '@dt/fe-utils'
import { modalLayer } from '@utils'
import { tipMobx, payPlanMobx } from '@mobxStore'
import { SelectTipModal } from '../../modal'
import './index.scss'

const Tip: FC = () => {
  if (tipMobx.tipOptions.length === 0) return null

  const selected = payPlanMobx.selectedTipOption

  const onClick = () => {
    modalLayer(SelectTipModal, null, 'selectTipModal')
      .then(() => { })
      .catch(() => { })
  }

  return (
    <div className='cart-box-item tip'>
      {/* <i className='iconfont icon-xiaofei2x' /> */}
      <div className='tip-info cart-item-left'>
        {i18n.t('pay.tip')}
        {/* {selected && selected.type === 'percent' && (
          <span className='tip-percent'>{format.toPercent(selected.percent)}</span>
        )} */}
      </div>
      <div className='mod-right used-discount' data-cypid='cartItemTip' onClick={onClick}>
        <span className='used-discount-price tip'>{selected && selected.type !== 'noTip' ? <span className='used-tip-price'>{`${selected.type === 'percent' ? `${format.toPercent(selected.percent)}(${format.toPrice(selected.amount)})` : format.toPrice(selected.amount)} `}</span> : i18n.t('pay.selectTip')}</span>
        <i className='iconfont icon-chevron-right' />
      </div>
      {/* <div className='tip-select' onClick={onClick}>
        {selected ? format.toPrice(selected.amount) : i18n.t('pay.selectTip')}
      </div> */}
    </div>
  )
}

export default observer(Tip)
